import React, { useState } from "react";
import emailjs, { EmailJSResponseStatus } from "@emailjs/browser";

const RequestInformationForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    business: "",
    model: "",
    companyName: "",
    country: "",
    city: "",
    zipCode: "",
    request: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.business) newErrors.business = "Please select a business.";
    if (!form.model) newErrors.model = "Please select a model.";
    if (!form.companyName.trim())
      newErrors.companyName = "Company Name is required.";
    if (!form.country.trim()) newErrors.country = "Country is required.";
    if (!form.city.trim()) newErrors.city = "City is required.";
    if (!form.zipCode.trim()) newErrors.zipCode = "Zip Code is required.";
    if (!form.request.trim()) newErrors.request = "Please enter your request.";
    if (!form.consent) newErrors.consent = "You must consent to continue.";
    return newErrors;
  };

  const handleRequestInformation = async (data) => {
    setIsLoading(true);
    try {
      await emailjs.send("service_dyax4v9", "template_qdahvs8", data, {
        publicKey: "MFEyetXb874CYjEUe",
      });
      setForm({
        business: "",
        model: "",
        companyName: "",
        country: "",
        city: "",
        zipCode: "",
        request: "",
        consent: false,
      });
      setIsLoading(false);
      console.log("SUCCESS!");
    } catch (err) {
      if (err instanceof EmailJSResponseStatus) {
        console.log("EMAILJS FAILED...", err);
        return;
      }
      setIsLoading(false);
      console.log("ERROR", err);
    }
    setIsLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      const form = e.target;
      const values = {
        business_interest: form.elements?.business?.value,
        model_interest: form.elements?.model?.value,
        company_name: form.elements?.companyName?.value,
        country: form.elements?.country?.value,
        city: form.elements?.city?.value,
        zip_code: form.elements?.zipCode?.value,
        request: form.elements?.request?.value,
      };
      handleRequestInformation(values);
      // TODO: handle submission logic here
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <div className="section bg-white">
      <div className=" section-title pt-[15px] lg:py-[30px]" data-aos="fade-up">
        <span className="subtitle">Request a Information</span>
        {/* <h2>Contact Us</h2> */}
      </div>
      <form onSubmit={handleSubmit} noValidate className="container mb-4">
        {/* Use grid container with responsive 2-cols on lg, 1-col on sm */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {/* Business Select */}
          <div>
            <label
              htmlFor="business"
              className="block font-semibold mb-1 text-gray-700"
            >
              Are you interested in a specific <strong>business</strong>?
              <span className="text-red-600 ml-1">*</span>
            </label>
            <select
              id="business"
              name="business"
              value={form.business}
              onChange={handleChange}
              aria-required="true"
              aria-describedby="business-error"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400 transition ${
                errors.business ? "border-red-600" : "border-gray-300"
              }`}
            >
              <option value="" disabled>
                Select a business
              </option>
              <option value="Ice Cream">Ice Cream</option>
              <option value="Coffee">Coffee</option>
              <option value="Delivery">Delivery</option>
              <option value="Sweets">Sweets</option>
              <option value="Drinks">Drinks</option>
              <option value="Fried Foods">Fried Foods</option>
              <option value="Gelato">Gelato</option>
              <option value="Pasta">Pasta</option>
              <option value="Pizza">Pizza</option>
              <option value="Dining">Dining</option>
              <option value="Sushi">Sushi</option>
              <option value="None of the above">None of the above</option>
            </select>
            {errors.business && (
              <p
                id="business-error"
                className="text-red-600 mt-1 text-sm"
                role="alert"
              >
                {errors.business}
              </p>
            )}
          </div>

          {/* Model Select */}
          <div>
            <label
              htmlFor="model"
              className="block font-semibold mb-1 text-gray-700"
            >
              Are you interested in a specific <strong>model</strong>?
              <span className="text-red-600 ml-1">*</span>
            </label>
            <select
              id="model"
              name="model"
              value={form.model}
              onChange={handleChange}
              aria-required="true"
              aria-describedby="model-error"
              className={`w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-orange-400 transition ${
                errors.model ? "border-red-600" : "border-gray-300"
              }`}
            >
              <option value="" disabled>
                Select a model
              </option>
              <option value="Parlour On Wheels">Parlour On Wheels</option>
              <option value="Tricyle Carts/ Push Cart">
                Tricyle Carts/ Push Cart
              </option>
              <option value="E-carts / E Rcikshaw">E-carts / E Rcikshaw</option>
            </select>
            {errors.model && (
              <p
                id="model-error"
                className="text-red-600 mt-1 text-sm"
                role="alert"
              >
                {errors.model}
              </p>
            )}
          </div>

          {/* Company Name */}
          <div>
            <label htmlFor="companyName" className="block font-medium mb-1">
              Company Name <span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              placeholder="Company Name"
              value={form.companyName}
              onChange={handleChange}
              aria-invalid={errors.companyName ? "true" : "false"}
              aria-describedby="companyName-error"
              required
              className={`w-full px-3 py-2 border rounded ${
                errors.companyName ? "border-red-600" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-orange-400`}
            />
            {errors.companyName && (
              <p
                id="companyName-error"
                className="text-red-600 mt-1"
                role="alert"
              >
                {errors.companyName}
              </p>
            )}
          </div>

          {/* Country */}
          <div>
            <label htmlFor="country" className="block font-medium mb-1">
              Country <span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              id="country"
              name="country"
              placeholder="Country"
              value={form.country}
              onChange={handleChange}
              aria-invalid={errors.country ? "true" : "false"}
              aria-describedby="country-error"
              required
              className={`w-full px-3 py-2 border rounded ${
                errors.country ? "border-red-600" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-orange-400`}
            />
            {errors.country && (
              <p id="country-error" className="text-red-600 mt-1" role="alert">
                {errors.country}
              </p>
            )}
          </div>

          {/* City */}
          <div>
            <label htmlFor="city" className="block font-medium mb-1">
              City <span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              id="city"
              name="city"
              placeholder="City"
              value={form.city}
              onChange={handleChange}
              aria-invalid={errors.city ? "true" : "false"}
              aria-describedby="city-error"
              required
              className={`w-full px-3 py-2 border rounded ${
                errors.city ? "border-red-600" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-orange-400`}
            />
            {errors.city && (
              <p id="city-error" className="text-red-600 mt-1" role="alert">
                {errors.city}
              </p>
            )}
          </div>

          {/* Zip Code */}
          <div>
            <label htmlFor="zipCode" className="block font-medium mb-1">
              Zip Code <span className="text-red-600">*</span>
            </label>
            <input
              type="text"
              id="zipCode"
              name="zipCode"
              placeholder="Zip Code"
              value={form.zipCode}
              onChange={handleChange}
              aria-invalid={errors.zipCode ? "true" : "false"}
              aria-describedby="zipCode-error"
              required
              inputMode="decimal"
              className={`w-full px-3 py-2 border rounded ${
                errors.zipCode ? "border-red-600" : "border-gray-300"
              } focus:outline-none focus:ring-2 focus:ring-orange-400`}
            />
            {errors.zipCode && (
              <p id="zipCode-error" className="text-red-600 mt-1" role="alert">
                {errors.zipCode}
              </p>
            )}
          </div>
        </div>

        {/* Your Request (Long Answer) */}
        <div className="mt-6">
          <label htmlFor="request" className="block font-medium mb-1">
            Your Request <span className="text-red-600">*</span>
          </label>
          <textarea
            id="request"
            name="request"
            placeholder="Your Request*"
            value={form.request}
            onChange={handleChange}
            aria-invalid={errors.request ? "true" : "false"}
            aria-describedby="request-error"
            required
            rows={4}
            className={`w-full px-3 py-2 border rounded resize-none ${
              errors.request ? "border-red-600" : "border-gray-300"
            } focus:outline-none focus:ring-2 focus:ring-orange-400`}
          />
          {errors.request && (
            <p id="request-error" className="text-red-600 mt-1" role="alert">
              {errors.request}
            </p>
          )}
        </div>

        <div>
          <p>Fields indicated by an asterisk (*) are mandatory</p>
        </div>
        {/* Consent Checkbox */}
        <div className="flex items-start ">
          <input
            type="checkbox"
            id="consent"
            name="consent"
            checked={form.consent}
            onChange={handleChange}
            className="mt-1 mr-2 h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            aria-invalid={errors.consent ? "true" : "false"}
            aria-describedby="consent-error"
            required
          />
          <label htmlFor="consent" className="text-gray-700">
            I have read the{" "}
            <a
              href="https://www.tekneitalia.com/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              privacy
            </a>{" "}
            and I consent to the processing of personal data.
          </label>
        </div>
        {errors.consent && (
          <p id="consent-error" className="text-red-600 mt-1" role="alert">
            {errors.consent}
          </p>
        )}
        {/* Submit Button */}

        <div className="mt-3">
          <button
            type="submit"
            className="bg-orange-600 hover:bg-orange-700 text-white font-medium px-6 py-2 rounded"
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RequestInformationForm;
